<template>
  <div :class="[documentType, docOrientation]"
       class="content document"
  >

    <div v-show="showRaw" class="raw">
      <slot name="raw-header">

        <header class="raw-header">
          <img :src="logo" alt="" class="logo">
          <div class="header">
            <component
                :is="block.type"
                v-for="(block, key) in header"
                :key="key"
                :data="block"
            ></component>
          </div>
          <div class="page-counter"></div>
        </header>
      </slot>

      <div class="raw-body">
        <slot name="raw-body">
          <div
              v-for="(block, key) in body"
              class="page-block">

            <component
                :is="block.type"
                :key="'block-' + key"
                :data="block"
            ></component>
          </div>
        </slot>
      </div>

      <footer class="raw-footer">
        <slot name="raw-footer">
          <component
              :is="block.type"
              v-for="(block,key) in footer"
              :key="'block-footer-' + key"
              :data="block"
          ></component>
        </slot>
      </footer>
    </div>

    <document-page
        v-for="(page, key) in document.pages"
        :key="key"
        :body="page.content"
        :footer="page.footer"
        :header="page.header"
    ></document-page>

  </div>
</template>

<script>
import Vue
  from "vue"
import DocumentPage
  from './DocumentPage'
import BlockMixin
  from "../block/BlockMixin"
import {
  Document,
} from '../../model/Document'
import {
  Page,
} from '../../model/Page'
import {
  Table,
} from "../../model/table/Table"

export default {

  name: 'document-container',

  mixins: [BlockMixin],

  data() {
    return {
      document: new Document,
      showRaw: true,
      debug: false,
      showRendered: true,
      docOrientation: null,
      // renderDocument: false,
      renderDocument: true,
    }
  },

  props: {
    tables: {
      type: Object,
    },
    header: {
      type: Array,
    },
    body: {
      type: Array,
    },
    footer: {
      type: Array,
    },
    logo: {
      type: String,
    },
    documentType: {
      type: String,
      required: true,
    },
    timeout: {
      type: Number,
    },
  },

  created() {
    this.docOrientation = this.$route.query.orientation || 'portrait'
    this.$store.commit('addDocumentContainer')
  },

  mounted() {
    setTimeout(() => {
      console.log('rendering document')
      this.createDocument(this.$el.children[0], this.docOrientation)
    }, this._.get(this, 'timeout', 2000))

  },

  head: {
    style: function () {
      return [{
        type: 'text/css',
        inner: this.docOrientation === 'landscape' ? '@page { size: 297mm 210mm; margin: 0; }' : '@page { size: 210mm 297mm; margin: 0; }',
        undo: false,
      }]
    },
  },

  methods: {
    debugLog(msg) {
      if (this.debug) {
        console.log(msg)
      }
    },
    getTableHTML(table, breakPoint, currentRow) {
      if (typeof table.data === 'object') {
        table.data = Object.keys(table.data).map(el => table.data[el])
      }

      let tableObject = new Table(
          table.id,
          table.config,
          table.data.slice(breakPoint, currentRow),
          table.type,
          table.title,
          table.multiRowPath,
          table.useLegacyFormatting,
      )

      return new Vue(Object.assign({}, table.type, {
        propsData: {
          table: tableObject,
        },
      })).$mount()
    },

    getOuterHeight(el) {
      if (!el || el.length === 0) {
        return 0
      }
      let height = el.offsetHeight
      let style = getComputedStyle(el)

      height += parseInt(style.marginTop) + parseInt(style.marginBottom)
      return height
    },

    // clean DOM to prevent errors
    // vue creates comment tags when v-if evaluates to false
    // which can lead to wrong behavior in createDocument()
    cleanNode(node) {
      for (let n = 0; n < node.childNodes.length; n++) {
        let child = node.childNodes[n]
        if (
            child.nodeType === 8
            || (child.nodeType === 3 && !/\S/.test(child.nodeValue))
        ) {
          node.removeChild(child)
          n--
        } else if (child.nodeType === 1) {
          this.cleanNode(child)
        }
      }
    },

    createDocument(raw, orientation = 'portrait') {
      if (!this.renderDocument) {
        return
      }

      const margin = 50
      const header = raw.children[0] // the raw page header
      const body = raw.children[1].children // the raw body that contains page blocks
      const footer = raw.children[2] // the raw page footer
      const headerHeight = header.offsetHeight
      let bodyHeight
      let footerHeight

      if (this.documentType === 'portfolio') {
        footerHeight = footer.offsetHeight// account for page numbers
        bodyHeight = 684
      } else {
        footerHeight = footer.offsetHeight + 25 // account for page numbers
        bodyHeight = (orientation === 'portrait' ? 1100 : 780) - headerHeight - footerHeight - 2 * margin
      }

      this.debugLog(`header height: ${headerHeight}`)
      this.debugLog(`body height: ${bodyHeight}`)
      this.debugLog(`footer height: ${footerHeight}`)

      let currentPageHeight = 0
      let currentPage = getNewpage()

      function getNewpage() {
        console.log('--- starting new page ---')
        return new Page(header.innerHTML, footer.innerHTML)
      }

      function hasOverstepped(additionalOffset = 0) {
        let overStepped = currentPageHeight + additionalOffset > bodyHeight
        if (overStepped) {
          console.log('### OVERSTEPPED ###')
        }
        return overStepped
      }

      for (let block of body) {
        if (this._.get(block, 'children[0].className', []).includes('pagebreak')) {
          this.debugLog('breaking')
          this.document.addPages(currentPage)
          currentPage = getNewpage()
          currentPageHeight = 0
          continue
        }

        this.cleanNode(block)
        let blockHeight = block.offsetHeight

        currentPageHeight += blockHeight

        this.debugLog(block)
        this.debugLog(blockHeight + '/' + currentPageHeight)

        if (!hasOverstepped()) {
          currentPage.addContent(block.innerHTML)
        } else if (
            !block.children[0].className.includes('product-table')
            || block.children[0].className.includes('multi-report-table')
        ) {

          this.document.addPages(currentPage)
          currentPage = getNewpage()
          currentPage.addContent(block.innerHTML)
          currentPageHeight = block.offsetHeight
          this.debugLog(currentPageHeight)

        } else {

          // revert page height change and start over by filling it with product table rows
          currentPageHeight -= block.offsetHeight

          // define some variables for table layout
          let tableHeading = block.children[0].children[0]
          let table = block.children[0].children[1]
          let tableFooter = block.children[0].children[2]
          let tableHeader = this._.get(table, 'children[0]', [])
          let tableBody = this._.get(table, 'children[1]', [])

          // calculate overhead and try again
          let overhead = this.getOuterHeight(tableHeader) + this.getOuterHeight(tableHeading) + this.getOuterHeight(tableFooter) + 24
          let rowHeight = tableBody.children[0].offsetHeight

          // check if at least one row fits on the remaining page
          if (hasOverstepped(rowHeight + overhead)) {
            console.log('not even one row fits')

            // if one row doesn't fit, start new page
            this.document.addPages(currentPage)
            currentPage = getNewpage()
            currentPageHeight = 0
          }
          currentPageHeight += overhead

          // find row that oversteps the page boundaries
          // let currentRow = 0
          let breakPoint = 0

          let tableId = block.children[0].id
          let currentTableConfig = this.tables.findTable(tableId)

          // find h1 (group title, e.g. for shortlists) if it exists
          let h1 = [...tableHeading.children].find(el => el.tagName === 'H1')
          let prefix = h1 ? h1.outerHTML : ''
          let rowIndex = 0

          for (let productIndex in currentTableConfig.data) {
            let rowCount = currentTableConfig.multiRowPath ? this._.get(currentTableConfig.data[productIndex], currentTableConfig.multiRowPath, 0) : 1
            let addHeight = tableBody.children[rowIndex].offsetHeight

            if (currentTableConfig.multiRowPath) {
              for (let child = 1; child < rowCount; child++) {
                addHeight += tableBody.children[rowIndex + child].offsetHeight
              }
            }

            currentPageHeight += addHeight

            rowIndex += rowCount

            if (hasOverstepped()) {

              this.debugLog('overstepped on row ' + rowIndex + 1)
              // create table HTML and add page
              let vueTable = this.getTableHTML(
                  currentTableConfig,
                  breakPoint,
                  productIndex,
              )

              currentPage.addContent(prefix + vueTable.$el.outerHTML)
              this.document.addPages(currentPage)
              currentPage = getNewpage()
              currentPageHeight = overhead + addHeight
              breakPoint = productIndex
            }
          }

          let vueTable = this.getTableHTML(
              currentTableConfig,
              breakPoint,
              currentTableConfig.data.length,
          )

          currentPage.addContent(prefix + vueTable.$el.outerHTML)

        }
      }

      this.document.addPages(currentPage)
      this.showRaw = false

      this.$store.commit('incrementPageCount', this.document.getCount())
      this.$store.commit('removeDocumentContainer')

    },
  },

  components: {
    DocumentPage,
  },
}
</script>



// WEBPACK FOOTER //
// DocumentContainer.vue?61cde129